import type { AllRouteEndpoints } from "../routeTypes";
export const appsLegacyCatalogAccountsCacheKeys: AllRouteEndpoints[] = ["/apps/business/accounts_datatable"];
